import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick } from 'vue';
import { useUserStore } from '@/js/lib/store/user';
import { entryShop, validateShopEmail, type EntryShopData } from '@/js/lib/api/shop-entry';
import { confirm } from '@/js/lib/ui/confirm';
import { info, loading } from '@/js/lib/ui';
import { scrollToError } from '@/js/lib/helper/validate';
import { categories } from '@/js/data/category';
import FormWrapHasTitle from '@/js/components/organisms/FormWrapHasTitle.vue';
import FormSection from '@/js/components/organisms/FormSection.vue';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';

export type FormData = Omit<EntryShopData, 'isVintage' | 'isGranted'> & {
  isVintage: number;
  isGranted: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'entry-form',
  props: {
    isVintageForm: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isVintageForm?: boolean;
};


const userStore = useUserStore();
const itemLabel = props.isVintageForm ? '商品' : '作品';
const categorieList = props.isVintageForm ? categories().filter(({ slug }) => !['kids_baby', 'food'].includes(slug)) : categories();
const observer = ref();
const emailRef = ref();
const formData = ref<FormData>({
  email: '',
  name: '',
  address: '',
  phoneNumber: '',
  companyName: '',
  shopName: userStore.memberName || '',
  isVintage: Number(props.isVintageForm),
  siteUrl: '',
  instagramUrl: '',
  categories: [],
  isGranted: Number(!props.isVintageForm),
  freeArea: '',
});
const postEntry = async () => {
  try {
    return entryShop({
      ...formData.value,
      isVintage: Boolean(formData.value.isVintage),
      isGranted: Boolean(formData.value.isGranted),
    });
  } catch (error) {
    throw error.response.data.message;
  }
};
const onSubmit = async () => {
  const isValid = await observer.value.validate();
  if (!isValid) {
    scrollToError();
    return;
  }
  try {
    if (formData.value.email) {
      await validateShopEmail({ email: formData.value.email });
    }
    if (await confirm('内容を送信します。よろしいですか？')) {
      loading({
        asyncFunc: async () => {
          try {
            await postEntry();
            info(
              'お申し込みありがとうございました。\n\niichiより通常5営業日以内にメールにてご連絡差し上げます。\niichiからのメール(noreply@iichi.com)を受信できるように設定をお願いいたします。\n5営業日を過ぎてもメールの返信がない場合には、迷惑ボックス内もご確認の上、info@iichi.com までご連絡をお願いいたします。',
            );
          } catch (error) {
            info(error);
          }
        },
      });
    }
  } catch (error) {
    emailRef.value.$refs.provider.applyResult({
      errors: error.response.data.message,
    });
    nextTick(() => {
      scrollToError();
    });
    return;
  }
};

return { __sfc: true,props, userStore, itemLabel, categorieList, observer, emailRef, formData, postEntry, onSubmit, categories, FormWrapHasTitle, FormSection, IButton, ITextField, ITextArea }
}

})